<template>
  <div class="details-wrapper">
    <div class="details-header">
      <div>Permanent Placement #{{ permPlacement.reference_number }}</div>

      <Status :status="permPlacement.status" object-type="PERM_PLACEMENT" />
    </div>
    <div class="details-body">
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <section class="details-section">
            <PermPlacementDetailsForm :perm-placement="permPlacement" />
          </section>
        </div>
      </div>
      <div class="perm-status" :class="statusClass">
        {{ permPlacement.status }}
      </div>
    </div>
  </div>
</template>

<script>
import { AppActions } from '@/app/app.keys';
import { NewPermPlacementDetailsGetters } from '../new-perm-placement/new-perm-placement.keys';
import Status from '@/app/components/Status';
import PermPlacementDetailsForm from '../perm-placement-details/components/PermPlacementDetailsForm.vue';
import format from 'date-fns/format';

export default {
  name: 'PermPlacementDetails',
  components: { Status, PermPlacementDetailsForm },
  data() {
    return {
      sidebarMenu: [
        {
          label: this.$t('permPlacement.labels.details'),
          submenu: [
            { label: this.$t('permPlacement.labels.candidatePlaced') },
            { label: this.$t('permPlacement.labels.clientDetails') },
            { label: this.$t('permPlacement.labels.outsourceAndSplit') },
            { label: this.$t('permPlacement.labels.guarantee') },
            { label: this.$t('permPlacement.labels.stakeholdersDetails') },
            { label: this.$t('permPlacement.labels.miscDetails') }
          ]
        },
        { label: this.$t('permPlacement.labels.attachments') }
      ]
    };
  },
  computed: {
    statusClass() {
      let className = '';
      switch (this.permPlacement.status) {
        case 'DRAFT':
          className = 'draft';
          break;
        case 'SUBMITTED':
          className = 'submitted';
          break;
        case 'PROCESSED':
          className = 'processed';
          break;
        case 'CANCELLED':
          className = 'cancelled';
          break;
        case 'REJECTED':
          className = 'rejected';
          break;
        case 'OBSOLETE':
          className = 'obsolete';
          break;
        case 'FINISHED':
          className = 'finished';
          break;
      }
      return className;
    },
    permPlacement() {
      let permPlacement = this.$store.getters[NewPermPlacementDetailsGetters.PermPlacement];
      return permPlacement;
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('permPlacement.details.title'));
  },
  methods: {
    formatDate(d) {
      return d ? format(d, 'YYYY-MM-DD') : null;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;
  .details-header {
    display: flex;

    padding: $details-padding;
    border-bottom: 1px solid $row-border;
    justify-content: space-between;
  }

  .details-body {
    position: relative;
    border-bottom: 1px solid $row-border;
    display: flex;
    flex-direction: row;
    border-right: 4px solid rgba(255, 255, 255, 0);
    justify-content: center;
  }

  .content-panel-wrapper {
    flex: 0 85%;
    .content-panel {
      display: block;
      background-color: $white;
      padding: 60px;
    }
  }

  .details-section {
    padding-bottom: 25px;

    h1 {
      border-bottom: 1px solid $row-border;
    }
  }

  .perm-status {
    position: fixed;
    width: 170px;
    padding: 10px 0;
    transform: rotate(-90deg);
    top: 50%;
    right: 0;
    color: $white;
    font-weight: bold;
    text-align: center;
    &.draft {
      background-color: $light-grey-1;
      border: 1px solid $dark-grey-1;
    }
    &.submitted {
      background-color: $orange;
      border: 1px solid $secondary-orange;
    }
    &.active-online {
      background-color: $secondary-green;
      border: 1px solid $green;
    }
    &.finished {
      background-color: $blue;
      border: 1px solid $dark-blue;
    }
    &.rejected {
      background-color: $red;
      border: 1px solid $secondary-red;
    }
    &.obsolete {
      background-color: $red;
      border: 1px solid $secondary-red;
    }
    &.active-offline {
      background-color: $purple;
      border: 1px solid $purple;
    }
  }
}
</style>
